export default function fetchProfileSuccess(state, payload) {
  const {
    currentArea,
    description,
    expandedEquipped,
    isLoggedInUsersProfile,
    next,
    prev,
    profileCharacter,
    standardEquipped,
  } = payload;
  return {
    ...state,
    currentArea,
    description,
    expandedEquipped,
    isLoggedInUsersProfile,
    next,
    prev,
    profileCharacter,
    standardEquipped,
    isFetching: false,
    lookingAtOwnProfile: isLoggedInUsersProfile,
  };
}